import type { ReactNode } from 'react'
import { cx } from '../utils/cx'
import './ChargeList.css'

export interface ChargeItem {
  id: string
  concept: ReactNode
  /** Fecha, hora y estado del recibo: "4 oct, 08:31 · recibo enviado" */
  meta?: ReactNode
  /** Importe ya formateado */
  amount: ReactNode
}

export interface ChargeListProps {
  items: ChargeItem[]
  totalLabel: ReactNode
  total: ReactNode
  className?: string
}

/** Lista de cargos (bundle B3 §3g "Cargos realizados"): concepto, fecha e importe tabular, total al final. */
export function ChargeList({ items, totalLabel, total, className }: ChargeListProps) {
  return (
    <dl className={cx('hp-charges', className)}>
      {items.map((it) => (
        <div key={it.id} className="hp-charges__row">
          <dt>
            <span className="hp-charges__concept">{it.concept}</span>
            {it.meta && <span className="hp-charges__meta tnum">{it.meta}</span>}
          </dt>
          <dd className="tnum">{it.amount}</dd>
        </div>
      ))}
      <div className="hp-charges__row hp-charges__row--total">
        <dt>{totalLabel}</dt>
        <dd className="tnum">{total}</dd>
      </div>
    </dl>
  )
}
